export const PROMOTIONS_LIST_REQUEST = 'PROMOTIONS_LIST_REQUEST';
export const PROMOTIONS_LIST_SUCCESS = 'PROMOTIONS_LIST_SUCCESS';
export const PROMOTIONS_LIST_FAILURE = 'PROMOTIONS_LIST_FAILURE';

export function success(payload) {
  return dispatch => dispatch({ type: PROMOTIONS_LIST_SUCCESS, payload });
}

export function failure(payload) {
  return dispatch => dispatch({ type: PROMOTIONS_LIST_FAILURE, payload });
}

export default function list() {
  return dispatch => dispatch({ type: PROMOTIONS_LIST_REQUEST });
}
